import BenchlingConfig from 'BenchlingConfig';

import {
  StructuredTableKind,
  StructuredTableSchema,
  UnknownStructuredTable,
} from '../StructuredTableConstants';

export function shouldValidateStructuredTable(structuredTable: UnknownStructuredTable): boolean {
  return shouldValidateStructuredTableSchema(structuredTable.kind, structuredTable.schemas);
}

export function shouldValidateStructuredTableSchema(
  tableKind: StructuredTableKind,
  schemas: Array<StructuredTableSchema>
): boolean {
  if (!BenchlingConfig.ENABLE_STRUCTURED_TABLE_VALIDATION) {
    return false;
  }
  if (BenchlingConfig.PROCEDURES_RUN_PARAMETER_VALIDATIONS && tableKind === StructuredTableKind.PARAMETER) {
    return true;
  }
  return schemas.some((schema) => schema.hasValidationRules);
}
